module.exports = __webpack_public_path__ + "static/profile.ba819f9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/profile.jpg
// module id = ./src/images/profile.jpg
// module chunks = 7489246917808536000